import svgPanZoom from 'svg-pan-zoom'
import { getCitySvg } from '@/api/rim'
import mobileEvent from './mobile'

const redmarker = require('@/assets/imgs/metro-news2.jpeg')

export const mapOperation = {
  data () {
    return ({
      currentMapObj: null,
      assetColors: new Map(),
      gNodeList: [], // 全部地图线路
      pathNodeList: [], // 全部地图站点
      flickerMarker: require('@/assets/imgs/flicker_orange2.gif'),
      greenMarker: require('@/assets/imgs/green2.png'),
      orangeMarker: require('@/assets/imgs/orange2.png'),

      levelImgs: [
        require('@/assets/imgs/g.png'),
        require('@/assets/imgs/gr.png'),
        require('@/assets/imgs/b.png'),
        require('@/assets/imgs/yy.png'),
        require('@/assets/imgs/r.png')
      ]
    })
  },
  methods: {
    initMap (cityName, zoom = 1) {
      this.spinShow = true
      const data = { cityCode: this.chooseCity }

      getCitySvg(data).then(res => {
        this.svgHtml = res
        // 设置SVG地图的样式和缩放
        this.$nextTick(() => {
          // 设置svg呈现在画板上的尺寸
          document.getElementById('drawing').setAttribute('width', '100%')
          document.getElementById('drawing').setAttribute('height', '100%')

          this.currentMapObj = svgPanZoom('#drawing', {
            panEnabled: true,
            controlIconsEnabled: false,
            zoomEnabled: true,
            dblClickZoomEnabled: true,
            customEventsHandler: mobileEvent,
            minZoom: 1,
            maxZoom: 8,
            center: true
          })

          if (['350200', '330200', '710001', '710002', '150100'].indexOf(this.chooseCity) > -1) { // 厦门、香港、宁波地图太小
            this.currentMapObj.zoom(zoom > 1 ? zoom : 1)
          } else if (['120100', '370200'].indexOf(this.chooseCity) > -1) { // 天津地图太大
            this.currentMapObj.zoom(zoom > 1 ? zoom : 2)
          } else {
            this.currentMapObj.zoom(zoom > 1 ? zoom : 1.5)
          }

          // 存储线路颜色
          this.saveAssetColor()
          if (cityName) { this.cityName = cityName }
          this.spinShow = false
        })
      })
    },
    saveAssetColor () {
      this.assetColors = new Map()
      this.gNodeList = document.getElementsByTagName('g')
      this.pathNodeList = document.getElementsByTagName('path')

      // 存储线条颜色
      let gEl
      for (let i = 0; i < this.gNodeList.length; i++) {
        gEl = this.gNodeList[i]
        if (gEl.hasAttribute('data-assetid')) { // 当前节点包含线路ID
          if (!this.assetColors.get(gEl.getAttribute('data-assetid'))) {
            this.assetColors.set(gEl.getAttribute('data-assetid'), gEl.children[0].getAttribute('stroke'))
          }
        }
      }
      // 隐藏线路图标
      if (this.hideLineNumber) {
        let pEl
        for (let i = 0; i < this.pathNodeList.length; i++) {
          pEl = this.pathNodeList[i]
          if (pEl.getAttribute('stroke') && !pEl.hasAttribute('data-assetid') && !pEl.parentNode.hasAttribute('data-assetid')) { // 当前节点包含线路ID
            pEl.parentNode.setAttribute('opacity', 0)
          }
        }
      }
    },
    grayMapLines (assetList, stationList, dasharrayIssueList) {
      // 线条
      let gEl
      let lineAssetId
      let lineIssue
      let isInAssetList = false
      let currentAssetColor = ''
      for (let i = 0; i < this.gNodeList.length; i++) {
        gEl = this.gNodeList[i]
        if (gEl.hasAttribute('data-assetid') && gEl.hasAttribute('data-issue')) {
          // 隐藏线路，将线路颜色变为灰色
          lineAssetId = parseInt(gEl.getAttribute('data-assetid'))
          lineIssue = parseInt(gEl.getAttribute('data-issue'))

          if (this.pageType === 1) { // 线路开通
            isInAssetList = assetList.find(x => x.assetId === lineAssetId && x.issue === lineIssue)
          } else {
            isInAssetList = assetList.indexOf(lineAssetId) > -1
          }

          if (isInAssetList) {
            // 还原线路颜色， 移动端执行颜色渲染，需要耗费性能，需要验证优化
            currentAssetColor = this.assetColors.get(gEl.getAttribute('data-assetid'))
            if (currentAssetColor !== gEl.children[0].getAttribute('stroke')) {
              gEl.children[0].setAttribute('stroke', this.assetColors.get(gEl.getAttribute('data-assetid')))
              // 线路动画
              this.lineFocusAnimation(gEl.children[0])
            }

            // 如果线路还未开通， 那么就将线路属性虚线画
            if (dasharrayIssueList && dasharrayIssueList.length > 0 && dasharrayIssueList.find(x => x.assetId === lineAssetId && x.issue === lineIssue)) {
              gEl.children[0].setAttribute('stroke-dasharray', 20)
              gEl.children[0].setAttribute('stroke-dashoffset', 10)
              gEl.children[0].setAttribute('stroke', 'gray')
            }
          } else {
            gEl.children[0].setAttribute('stroke', 'Gainsboro')
            gEl.children[0].setAttribute('stroke-dasharray', 'none')
            gEl.children[0].removeAttribute('stroke-dashoffset')
          }
        }
      }

      // 站点
      let pEl
      let lineStationId
      let stationAssetId
      let flag
      for (let i = 0; i < this.pathNodeList.length; i++) {
        pEl = this.pathNodeList[i]
        if (pEl.hasAttribute('data-stationid') && pEl.hasAttribute('data-assetid')) {
          lineStationId = pEl.getAttribute('data-stationid')
          stationAssetId = pEl.getAttribute('data-assetid')
          flag = false
          if (this.pageType === 1) {
            if (lineStationId.split(',').length > 1) {
            // 如果是换乘站, 验证是否包含在显示线路目录中
              lineStationId.split(',').forEach(lineId => {
                if (stationList.indexOf(lineId) > -1) {
                  flag = true
                }
              })
            }
            flag = flag || stationList.indexOf(lineStationId) > -1
          } else if (this.pageType === 2) {
            if (stationAssetId.split(',').length > 1) {
            // 如果是换乘站, 验证是否包含在显示线路目录中
              stationAssetId.split(',').forEach(lineId => {
                if (assetList.indexOf(parseInt(lineId)) > -1) {
                  flag = true
                }
              })
            }

            flag = flag || assetList.indexOf(parseInt(stationAssetId)) > -1
          }

          if (flag) {
            // 还原站点颜色
            this.fillStationColor(pEl, true)
          } else {
            this.fillStationColor(pEl, false)
          }
        }
      }
    },
    grayMapLinesOpen (assetId, issue, stationList, openDate) {
      // 线条
      let gEl
      let lineAssetId
      let lineIssue
      let currentAssetColor = ''
      for (let i = 0; i < this.gNodeList.length; i++) {
        gEl = this.gNodeList[i]
        if (gEl.hasAttribute('data-assetid') && gEl.hasAttribute('data-issue')) {
          // 隐藏线路，将线路颜色变为灰色
          lineAssetId = parseInt(gEl.getAttribute('data-assetid'))
          lineIssue = parseInt(gEl.getAttribute('data-issue'))

          if (lineAssetId === assetId && lineIssue <= issue) {
            // 还原线路颜色， 移动端执行颜色渲染，需要耗费性能，需要验证优化
            currentAssetColor = this.assetColors.get(gEl.getAttribute('data-assetid'))
            if (currentAssetColor !== gEl.children[0].getAttribute('stroke')) {
              gEl.children[0].setAttribute('stroke', this.assetColors.get(gEl.getAttribute('data-assetid')))
              // 线路动画
              this.lineFocusAnimation(gEl.children[0])
            }
            // 如果线路还未开通， 那么就将线路属性虚线画
            if (new Date(openDate) > new Date()) {
              gEl.children[0].setAttribute('stroke-dasharray', 20)
              gEl.children[0].setAttribute('stroke-dashoffset', 10)
              gEl.children[0].setAttribute('stroke', '#000')
            }
          } else {
            gEl.children[0].setAttribute('stroke', 'Gainsboro')
            gEl.children[0].setAttribute('stroke', 'Gainsboro')
            gEl.children[0].setAttribute('stroke-dasharray', 'none')
            gEl.children[0].removeAttribute('stroke-dashoffset')
          }
        }
      }

      // 站点
      let pEl
      let lineStationId
      let flag
      for (let i = 0; i < this.pathNodeList.length; i++) {
        pEl = this.pathNodeList[i]
        if (pEl.hasAttribute('data-stationid') && pEl.hasAttribute('data-assetid')) {
          lineStationId = pEl.getAttribute('data-stationid')
          flag = false
          if (lineStationId.split(',').length > 1) {
            // 如果是换乘站, 验证是否包含在显示线路目录中
            lineStationId.split(',').forEach(lineId => {
              if (stationList.indexOf(lineId) > -1) {
                flag = true
              }
            })
          }
          flag = flag || stationList.indexOf(lineStationId) > -1

          if (flag) {
            // 还原站点颜色
            this.fillStationColor(pEl, true)
          } else {
            this.fillStationColor(pEl, false)
          }
        }
      }
    },
    hideMapLines (assetList, stationList) {
      // 线条
      let gEl
      let lineAssetId
      let lineIssue
      let isInAssetList = false
      let currentAssetColor = ''
      for (let i = 0; i < this.gNodeList.length; i++) {
        gEl = this.gNodeList[i]
        if (gEl.hasAttribute('data-assetid') && gEl.hasAttribute('data-issue')) {
          // 隐藏线路，将线路颜色变为灰色
          lineAssetId = parseInt(gEl.getAttribute('data-assetid'))

          if (this.pageType === 1) { // 线路开通
            lineIssue = parseInt(gEl.getAttribute('data-issue'))
            isInAssetList = assetList.find(x => x.assetId === lineAssetId && x.issue === lineIssue)
          } else {
            isInAssetList = assetList.indexOf(lineAssetId) > -1
          }

          if (isInAssetList) {
            gEl.children[0].setAttribute('display', 'inline')
            // 还原线路颜色， 移动端执行颜色渲染，需要耗费性能，需要验证优化
            currentAssetColor = this.assetColors.get(gEl.getAttribute('data-assetid'))
            if (currentAssetColor !== gEl.children[0].getAttribute('stroke')) {
              // 线路动画
              gEl.children[0].setAttribute('stroke', this.assetColors.get(gEl.getAttribute('data-assetid')))
              this.lineFocusAnimation(gEl.children[0])
            }
          } else {
            gEl.children[0].setAttribute('display', 'none')
            gEl.children[0].setAttribute('stroke', 'Gainsboro')
          }
        }
      }

      // 站点
      let pEl
      let lineStationId
      let stationAssetId
      let flag
      for (let i = 0; i < this.pathNodeList.length; i++) {
        pEl = this.pathNodeList[i]
        if (pEl.hasAttribute('data-stationid') && pEl.hasAttribute('data-assetid')) {
          lineStationId = pEl.getAttribute('data-stationid')
          stationAssetId = pEl.getAttribute('data-assetid')
          flag = false
          if (this.pageType === 1) {
            if (lineStationId.split(',').length > 1) {
            // 如果是换乘站, 验证是否包含在显示线路目录中
              lineStationId.split(',').forEach(lineId => {
                if (stationList.indexOf(lineId) > -1) {
                  flag = true
                }
              })
            }
            flag = flag || stationList.indexOf(lineStationId) > -1
          } else if (this.pageType === 2) {
            if (stationAssetId.split(',').length > 1) {
            // 如果是换乘站, 验证是否包含在显示线路目录中
              stationAssetId.split(',').forEach(lineId => {
                if (assetList.indexOf(parseInt(lineId)) > -1) {
                  flag = true
                }
              })
            }

            flag = flag || assetList.indexOf(parseInt(stationAssetId)) > -1
          }

          if (flag) { // 显示站点文字信息
            pEl.setAttribute('display', 'inline')
            if (pEl.nextElementSibling) {
              pEl.nextElementSibling.children[0].setAttribute('display', 'inline')
            }
          } else {
            pEl.setAttribute('display', 'none')
            if (pEl.nextElementSibling) {
              pEl.nextElementSibling.children[0].setAttribute('display', 'none')
            }
          }
        }
      }
    },
    fillLineGray (assetList, stationList, focusStationId, dynamicLevel, dasharrayIssueList) {
      this.removeElement('metro_marker')
      this.removeElement('metro_text')
      // 线条
      let gEl
      let lineAssetId
      let lineIssue
      let isInAssetList = false
      for (let i = 0; i < this.gNodeList.length; i++) {
        gEl = this.gNodeList[i]
        if (gEl.hasAttribute('data-assetid') && gEl.hasAttribute('data-issue')) {
          // 隐藏线路，将线路颜色变为灰色
          lineAssetId = parseInt(gEl.getAttribute('data-assetid'))
          lineIssue = parseInt(gEl.getAttribute('data-issue'))

          if (this.pageType === 1) { // 线路开通
            isInAssetList = assetList.find(x => x.assetId === lineAssetId && x.issue === lineIssue)
          } else {
            isInAssetList = assetList.indexOf(lineAssetId) > -1
          }

          if (isInAssetList) {
            gEl.children[0].setAttribute('stroke', '#808695')
            // 如果线路还未开通， 那么就将线路属性虚线画
            if (dasharrayIssueList && dasharrayIssueList.length > 0 && dasharrayIssueList.find(x => x.assetId === lineAssetId && x.issue === lineIssue)) {
              gEl.children[0].setAttribute('stroke-dasharray', 20)
              gEl.children[0].setAttribute('stroke-dashoffset', 10)
              gEl.children[0].setAttribute('stroke', 'gray')
            }
          } else {
            gEl.children[0].setAttribute('stroke', 'Gainsboro')
            gEl.children[0].setAttribute('stroke-dasharray', 'none')
            gEl.children[0].removeAttribute('stroke-dashoffset')
          }
        }
      }

      // 站点
      let pEl
      let lineStationId
      let flag
      let choose
      let inPurchase
      let stationLevel
      let stationIds = stationList.map(x => x.stationId)
      for (let i = 0; i < this.pathNodeList.length; i++) {
        pEl = this.pathNodeList[i]
        if (pEl.hasAttribute('data-stationid') && pEl.hasAttribute('data-assetid')) {
          lineStationId = pEl.getAttribute('data-stationid')
          flag = false
          choose = false
          inPurchase = false
          stationLevel = 0
          if (lineStationId.split(',').length > 1) {
            // 如果是换乘站, 验证是否包含在显示线路目录中
            lineStationId.split(',').forEach(lineId => {
              if (stationIds.indexOf(lineId) > -1) {
                flag = true
              }

              if (lineId === focusStationId) {
                choose = true
              }

              if (stationList.find(x => x.stationId === lineId) && !inPurchase) {
                inPurchase = stationList.find(x => x.stationId === lineId).inPurchase
                stationLevel = stationList.find(x => x.stationId === lineId).level
              }
            })
          } else if (stationList.find(x => x.stationId === lineStationId)) {
            inPurchase = stationList.find(x => x.stationId === lineStationId).inPurchase
            stationLevel = stationList.find(x => x.stationId === lineStationId).level
          }

          flag = flag || stationIds.indexOf(lineStationId) > -1
          choose = choose || focusStationId === lineStationId

          if (choose && pEl.getAttribute('name') !== 'standardText') { // 选中状态，添加一个红色闪烁图标
            pEl.after(this.generateFlickerImageMarker(this, lineStationId, pEl.getAttribute('name')))
          } else if (flag) { // 还原站点颜色
            this.fillStationColorGray(pEl, true)
            // 覆盖一个允许选择的图标
            if (pEl.getAttribute('name') !== 'standardText') {
              pEl.after(this.generateResourceImageMarkerEvent(this, lineStationId, pEl.getAttribute('name'), this.checkGrayMapMarker(inPurchase, stationLevel, dynamicLevel)))
            }
          } else {
            this.fillStationColorGray(pEl, false, assetList.includes(parseInt(pEl.getAttribute('data-assetid'))))
          }
        }
      }
    },
    fillStationColorGray (pEl, isShow, inAssetList) { // 用于官网灰色地图站点
      let stationFill = 'Gainsboro'
      let stationStroke = 'Gainsboro'
      let stationText = 'Gainsboro'

      if (isShow) {
        stationStroke = this.assetColors.get(pEl.getAttribute('data-assetid'))
        stationFill = '#ffffff'
        stationText = '#000000'
      }

      if (pEl.getAttribute('name') === 'standardText') { // 常规站点文字
        // 需要验证是否验证是否相等， 否则在移动端渲染会出现性能问题
        if (pEl.nextElementSibling.children[0].getAttribute('fill', stationText) !== stationText) {
          pEl.nextElementSibling.children[0].setAttribute('fill', stationText)
        }
      } else if (pEl.getAttribute('name') === 'p_r_station') { // 换乘站
        // 需要验证是否验证是否相等， 否则在移动端渲染会出现性能问题
        let display = isShow ? '' : 'none'
        if (pEl.getAttribute('display') !== display) {
          pEl.setAttribute('display', isShow ? '' : 'none')
        }
      } else { // 站点圆圈
        // 确认是否包含在可用线路内
        if (inAssetList) {
          pEl.setAttribute('stroke', '#808695')
          pEl.setAttribute('fill', '#808695')
        } else if (pEl.getAttribute('stroke', stationStroke) !== stationStroke) {
          pEl.setAttribute('stroke', stationStroke)
          pEl.setAttribute('fill', stationFill)
        }
      }
    },
    fillStationColor (pEl, isShow) {
      let stationFill = 'Gainsboro'
      let stationStroke = 'Gainsboro'
      let stationText = 'Gainsboro'

      if (isShow) {
        stationStroke = this.assetColors.get(pEl.getAttribute('data-assetid'))
        stationFill = '#ffffff'
        stationText = '#000000'
      }

      if (pEl.getAttribute('name') === 'standardText') { // 常规站点
        // 需要验证是否验证是否相等， 否则在移动端渲染会出现性能问题
        if (pEl.nextElementSibling.children[0].getAttribute('fill', stationText) !== stationText) {
          pEl.nextElementSibling.children[0].setAttribute('fill', stationText)
        }
      } else if (pEl.getAttribute('name') === 'p_r_station') { // 换乘站
        // 需要验证是否验证是否相等， 否则在移动端渲染会出现性能问题
        let display = isShow ? '' : 'none'
        if (pEl.getAttribute('display') !== display) {
          pEl.setAttribute('display', isShow ? '' : 'none')
        }
      } else { // 站点圆圈
        // 需要验证是否验证是否相等， 否则在移动端渲染会出现性能问题
        if (pEl.getAttribute('stroke', stationStroke) !== stationStroke) {
          pEl.setAttribute('stroke', stationStroke)
          pEl.setAttribute('fill', stationFill)
        }
      }
    },
    handleMapAnimation (targetPoint) {
      let _this = this
      const currentPan = this.currentMapObj.getPan()

      var animationTime = 300 // ms
      var animationStepTime = 30 // one frame per 30 ms
      var animationSteps = animationTime / animationStepTime
      var animationStep = 0
      var intervalID = null
      var stepX = (currentPan.x - targetPoint.x) / animationSteps
      var stepY = (currentPan.y - targetPoint.y) / animationSteps

      intervalID = setInterval(function () {
        if (animationStep++ < animationSteps) {
          _this.currentMapObj.pan({ x: currentPan.x - stepX * animationStep, y: currentPan.y - stepY * animationStep })
        } else {
          // 取消无限循环
          clearInterval(intervalID)
        }
      }, animationStepTime)
    },
    handleMapGetCenter (line, needGrayLine = true, dasharrayIssueList) {
      if (needGrayLine) {
        this.grayMapLines([line.id], [], dasharrayIssueList)
      }

      let centerStationId = line.centerStationId.toString()
      let centerPoint = { x: 0, y: 0 }
      let pEl

      for (let i = 0; i < this.pathNodeList.length; i++) {
        pEl = this.pathNodeList[i]
        if (pEl.hasAttribute('data-stationid') && (pEl.getAttribute('name') === 'p_station' || pEl.getAttribute('name') === 'p_r_station')) {
          if (pEl.getAttribute('data-stationid').split(',').indexOf(centerStationId) > -1) {
            let centerPointStr = pEl.parentNode.getAttribute('transform').substr(10).split(')')[0].split(' ')
            centerPoint.x = parseInt(centerPointStr[0])
            centerPoint.y = parseInt(centerPointStr[1])
            break
          }
        }
      }

      // 计算出实际跳转坐标
      const svgSizes = this.currentMapObj.getSizes()
      const newPoint = {
        x: -(centerPoint.x * svgSizes.realZoom) + (svgSizes.width / 2),
        y: -(centerPoint.y * svgSizes.realZoom) + (svgSizes.height / 2)
      }

      this.handleMapAnimation(newPoint)
    },
    handleMapGetLineOpenCenter (lineId, openInfo) {
      this.grayMapLinesOpen(lineId, openInfo.index, openInfo.stationIds, openInfo.openDate)

      let centerPoint = { x: 0, y: 0 }
      let pEl

      for (let i = 0; i < this.pathNodeList.length; i++) {
        pEl = this.pathNodeList[i]
        if (pEl.hasAttribute('data-stationid') && (pEl.getAttribute('name') === 'p_station' || pEl.getAttribute('name') === 'p_r_station')) {
          if (pEl.getAttribute('data-stationid').split(',').indexOf(openInfo.centerStationId) > -1) {
            let centerPointStr = pEl.parentNode.getAttribute('transform').substr(10).split(')')[0].split(' ')
            centerPoint.x = parseInt(centerPointStr[0])
            centerPoint.y = parseInt(centerPointStr[1])
            break
          }
        }
      }

      // 计算出实际跳转坐标
      const svgSizes = this.currentMapObj.getSizes()
      const newPoint = {
        x: -(centerPoint.x * svgSizes.realZoom) + (svgSizes.width / 2),
        y: -(centerPoint.y * svgSizes.realZoom) + (svgSizes.height / 2)
      }

      this.handleMapAnimation(newPoint)
    },
    handleMoveMarkerCenterByStation (startStationId, endStationId) {
      const startMarker = document.getElementsByClassName('metro_marker')[0]
        .parentNode.getAttribute('transform').substr(10).split(')')[0].split(' ')

      const startPoint = {
        x: parseInt(startMarker[0]),
        y: parseInt(startMarker[1])
      }

      let endPoint
      let pEl

      for (let i = 0; i < this.pathNodeList.length; i++) {
        pEl = this.pathNodeList[i]
        if (pEl.hasAttribute('data-stationid') && (pEl.getAttribute('name') === 'p_station' || pEl.getAttribute('name') === 'p_r_station') &&
          this.checkStationidInList(pEl.getAttribute('data-stationid'), endStationId.toString())) {
          const centerPointStr = pEl.parentNode.getAttribute('transform').substr(10).split(')')[0].split(' ')
          endPoint = {
            x: parseInt(centerPointStr[0]),
            y: parseInt(centerPointStr[1])
          }
          // 退出循环
          break
        }
      }

      // 计算出实际跳转坐标
      const svgSizes = this.currentMapObj.getSizes()
      if (endPoint) { // 处理关闭窗口后的空值
        const newPoint = {
          x: -(endPoint.x * svgSizes.realZoom) + (svgSizes.width / 2),
          y: -(endPoint.y * svgSizes.realZoom) + (svgSizes.height / 2)
        }

        const oldPoint = {
          x: -(startPoint.x * svgSizes.realZoom) + (svgSizes.width / 2),
          y: -(startPoint.y * svgSizes.realZoom) + (svgSizes.height / 2)
        }

        this.handleMoveMarkerAndAnimation(oldPoint, newPoint)
      }
    },
    handleMoveMarkerAndAnimation (startPoint, targetPoint) {
      let _this = this
      var animationTime = 300 // ms
      var animationStepTime = 30 // one frame per 30 ms
      var animationSteps = animationTime / animationStepTime
      var animationStep = 0
      var intervalID = null
      var stepX = (startPoint.x - targetPoint.x) / animationSteps
      var stepY = (startPoint.y - targetPoint.y) / animationSteps

      intervalID = setInterval(function () {
        if (animationStep++ < animationSteps) {
          _this.currentMapObj.pan({ x: startPoint.x - stepX * animationStep, y: startPoint.y - stepY * animationStep })
        } else {
          // 取消无限循环
          clearInterval(intervalID)
        }
      }, animationStepTime)
    },
    lineFocusAnimation (element) {
      let startSize = element.getAttribute('stroke-width')

      var animationTime = 500 // ms
      var animationStepTime = 50 // one frame per 30 ms
      var animationSteps = animationTime / animationStepTime
      var animationStep = 0
      var intervalID = null

      intervalID = setInterval(function () {
        if (animationStep++ < animationSteps) {
          if (animationStep < 6) {
            element.setAttribute('stroke-width', startSize * animationStep)
          } else {
            element.setAttribute('stroke-width', startSize * (11 - animationStep))
          }
        } else {
          // 取消无限循环
          clearInterval(intervalID)
        }
      }, animationStepTime)
    },
    loadFlickerStations (stationIds) {
      this.removeElement('metro_marker')
      this.removeElement('metro_text')
      if (stationIds.length < 1) { return }

      // 遍历添加新的数据
      for (let i = 0; i < this.pathNodeList.length; i++) {
        stationIds.forEach(element => {
          const el = this.pathNodeList[i]
          const pathStationId = element.toString()

          if (el.hasAttribute('data-stationid') && el.getAttribute('name') !== 'standardText' &&
             this.checkStationidInList(el.getAttribute('data-stationid'), pathStationId)) {
            el.after(this.generateFlickerImageMarker(this, el.getAttribute('data-stationid'), el.getAttribute('name')))
          }
        })
      }
    },
    loadResourceStations (stations, flickerStationId = null, isFlicker = true) {
      this.removeElement('metro_marker')
      this.removeElement('metro_text')
      if (stations.length < 1) { return }

      // 遍历添加新的数据
      for (let i = 0; i < this.pathNodeList.length; i++) {
        stations.forEach(element => {
          const el = this.pathNodeList[i]
          const pathStationId = element.stationId.toString()

          if (el.hasAttribute('data-stationid') && el.getAttribute('name') !== 'standardText' &&
             this.checkStationidInList(el.getAttribute('data-stationid'), pathStationId)) {
            if (pathStationId === flickerStationId) {
              // 添加闪烁点， 地图自动锚点到当前站点
              if (isFlicker) {
                el.after(this.generateFlickerImageMarker(this, el.getAttribute('data-stationid'), el.getAttribute('name')))
              } else if (el.nextSibling === null || el.nextSibling.nodeName === '#text') {
                // 将图标气泡添加到当前站点上方
                if (element.quantity) { // 如果包含数量， 那么添加数字。 否则不做处理
                  el.after(this.generateResourceTextMarker(this, element.quantity, el.getAttribute('data-stationid'), el.getAttribute('name')))
                }
                el.after(this.generateResourceImageMarker(this, el.getAttribute('data-stationid'), el.getAttribute('name')))
              }
              let centerPointStr = el.parentNode.getAttribute('transform').substr(10).split(')')[0].split(' ')
              let centerPoint = { x: parseInt(centerPointStr[0]),
                y: parseInt(centerPointStr[1])
              }
              // 计算出实际跳转坐标
              const svgSizes = this.currentMapObj.getSizes()
              const newPoint = {
                x: -(centerPoint.x * svgSizes.realZoom) + (svgSizes.width / 2),
                y: -(centerPoint.y * svgSizes.realZoom) + (svgSizes.height / 2)
              }

              this.handleMapAnimation(newPoint)
            } else if (el.nextSibling === null || el.nextSibling.nodeName === '#text') {
              // 将图标气泡添加到当前站点上方
              el.after(this.generateResourceTextMarker(this, element.quantity, el.getAttribute('data-stationid'), el.getAttribute('name')))
              el.after(this.generateResourceImageMarker(this, el.getAttribute('data-stationid'), el.getAttribute('name')))
            }
          }
        })
      }
    },
    removeElement (elementName) {
      // let imgMarkers = document.getElementsByName(elementName)   火狐居然不支持这个，我日
      const imgMarkers = document.getElementsByClassName(elementName)
      if (imgMarkers.length > 0) {
        imgMarkers[0].parentNode.removeChild(imgMarkers[0])
        return this.removeElement(elementName)
      } else {
        return false
      }
    },
    checkStationidInList (list, id) {
      const Ids = list.split(',')
      if (Ids.length > 1) {
        return Ids.includes(id)
      } else {
        return Ids[0] === id
      }
    },
    generateFlickerImageMarker (base, stationId, name) {
      // 气泡图标
      const image = document.createElementNS('http://www.w3.org/2000/svg', 'image')
      image.setAttribute('x', this.checkStationPoint(name)[0])
      image.setAttribute('y', this.checkStationPoint(name)[1])
      image.setAttribute('width', '97')
      image.setAttribute('height', '97')
      image.setAttribute('class', 'metro_marker')
      image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', this.flickerMarker)
      image.setAttribute('cursor', 'pointer')
      image.addEventListener('click', () => {
        base.handleClickCurrentStation(stationId)
      })
      return image
    },
    checkStationPoint (stationName) {
      const flag = stationName === 'p_r_station'

      if (this.chooseCity === '370200') {
        if (flag) {
          return ['-31', '-31']
        } else {
          return ['-39', '-39']
        }
      } else {
        if (flag) {
          return ['-30', '-30']
        } else {
          return ['-40', '-40']
        }
      }
    },
    generateResourceImageMarker (base, stationId, name) {
      // 气泡图标
      const image = document.createElementNS('http://www.w3.org/2000/svg', 'image')
      image.setAttribute('x', -10)
      image.setAttribute('y', -30)
      image.setAttribute('width', '80')
      image.setAttribute('height', '80')
      image.setAttribute('class', 'metro_marker')
      image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', redmarker)
      image.setAttribute('cursor', 'pointer')
      image.addEventListener('click', () => {
        base.handleClickStation(stationId)
      })

      return image
    },
    generateResourceTextMarker (base, quantity, stationId, name) {
      // 显示可用媒体数量
      const text = document.createElementNS('http://www.w3.org/2000/svg', 'text')
      if (quantity > 99) {
        text.setAttribute('x', this.checkTextPoint(name)[0] - 8)
      } else if (quantity > 9) {
        text.setAttribute('x', this.checkTextPoint(name)[0])
      } else { text.setAttribute('x', this.checkTextPoint(name)[0] + 5) }

      text.setAttribute('y', this.checkTextPoint(name)[1])
      text.setAttribute('font-size', '20')
      // text.setAttribute('name', 'metro_text')
      text.setAttribute('class', 'metro_text')
      text.setAttribute('fill', '#ffffff')
      text.textContent = quantity
      text.setAttribute('cursor', 'pointer')
      text.addEventListener('click', () => {
        base.handleClickStation(stationId)
      })

      return text
    },
    generateResourceImageMarkerEvent (base, stationId, name, marker) {
      // 气泡图标
      const image = document.createElementNS('http://www.w3.org/2000/svg', 'image')
      image.setAttribute('x', this.checkImgPointEvent(name)[0])
      image.setAttribute('y', this.checkImgPointEvent(name)[1])
      image.setAttribute('width', '38')
      image.setAttribute('height', '38')
      image.setAttribute('class', 'metro_marker')
      image.setAttribute('cursor', 'pointer')
      image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', marker)
      image.addEventListener('click', () => {
        base.handleClickStation(stationId, null)
      })

      return image
    },
    checkImgPoint (name) {
      if (this.chooseCity === '370200') { // 青岛地铁的地图样式和厦门不一样
        if (name === 'p_r_station') {
          return [0, -50]
        } else {
          return [-13, -60]
        }
      } else {
        if (name === 'p_r_station') {
          return [-10, -55]
        } else {
          return [-15, -60]
        }
      }
    },
    checkImgPointEvent (name) {
      if (name === 'p_r_station') {
        return [-5, -5]
      } else {
        return [-13, -13]
      }
    },
    checkGrayMapMarker (inPurchase, stationLevel, dynamicLevel) {
      if (dynamicLevel > 0) {
        let start = 5 - dynamicLevel
        let allowColor = []

        for (let index = start; index < 5; index++) {
          allowColor.push(this.levelImgs[index])
        }

        return allowColor[stationLevel - 1]
      } else {
        return inPurchase ? this.greenMarker : this.orangeMarker
      }
    },
    checkTextPoint (name) {
      if (name === 'p_r_station') {
        return [0, -12]
      } else {
        return [-7, -18]
      }
    }
  }
}
